import React from 'react';

import { ProjectSubmissionForm } from '../../../components/project-submission/ProjectSubmissionForm.component';
import { ProjectSubmissionHeader } from './ProjectSubmissionHeader.container';

interface Props {}

export const ProjectSubmissionPage: React.FC<Props> = () => {
  return (
    <div className="flex flex-col items-center">
      <ProjectSubmissionHeader />
      <ProjectSubmissionForm />
    </div>
  );
};
